import { BrowserRouter, Route, Routes } from "react-router-dom";
import MesAppShell from "../layouts/mes-app-shell";
import MesOperation from "../pages/mes-operations/mes-operations";
import MesCreateOrder from "../pages/mes-orders/create-order/create-order";
import MesOrders from "../pages/mes-orders/mes-orders";
import CadManufacturing from "../pages/mes-orders/cad-manufacturing/cad-manufacturing";
import OrderDetail from "../pages/mes-orders/order-detail/order-detail";
import MesParts from "../pages/mes-parts/mes-parts";
import MesTasks from "../pages/mes-tasks/mes-tasks";
import MesWorkCenter from "../pages/mes-work-centers/mes-work-centers";
import MesWorkflows from "../pages/mes-workflows/mes-workflows";
import MesJobs from "../pages/mes.jobs/mes.jobs";
import MesJobDetail from "../pages/mes.jobs/mes-job-detail";
import MesJobGuided from "../pages/mes.jobs/mes-job-guided";
import MesLogin from "../pages/mes-login/mes-login";
import MesDashboard from "../pages/mes-dashboard/mes-dashboard";
import MesOperators from "../pages/mes-operators/mes-operators";
import TrurecipeLibrary from "../pages/trurecipe/trurecipe-library";
import TrurecipeRecipeDetail from "../pages/trurecipe/trurecipe-recipe-detail";
import CompareRecipes from "../pages/trurecipe/compare-recipes";
import GuidedInstructions from "../pages/trurecipe/guided-instructions";
import DigitalTwin from "../pages/trurecipe/digital-twin";
import { ToastContainer } from "react-toastify";

const Routing = () => {
  return (
    <div>
      <ToastContainer />

      <BrowserRouter>
        <div className="">
          <div className="clsToogleOpen clsMainPage">
            <Routes>
              <Route path="/" element={<MesLogin />} />
              <Route element={<MesAppShell />}>
                <Route path="/mes-dashboard" element={<MesDashboard />} />
                <Route path="/mes-order" element={<MesOrders />} />
                <Route path="/mes-order/order/:orderId" element={<OrderDetail />} />
                <Route path="/mes-order/cad-manufacturing" element={<CadManufacturing />} />
                <Route path="/mes-trurecipe/library" element={<TrurecipeLibrary />} />
                <Route path="/mes-trurecipe/recipe/:recipeId" element={<TrurecipeRecipeDetail />} />
                <Route path="/mes-trurecipe/compare" element={<CompareRecipes />} />
                <Route path="/mes-trurecipe/guided" element={<GuidedInstructions />} />
                <Route path="/mes-trurecipe/digital-twin" element={<DigitalTwin />} />
                <Route path="/create-order" element={<MesCreateOrder />} />
                <Route path="/mes-parts" element={<MesParts />} />
                <Route path="/mes-jobs/:jobId/guided/:stepIndex" element={<MesJobGuided />} />
                <Route path="/mes-jobs/:jobId" element={<MesJobDetail />} />
                <Route path="/mes-jobs" element={<MesJobs />} />
                <Route path="/mes-workflow" element={<MesWorkflows />} />
                <Route path="/mes-operations" element={<MesOperation />} />
                <Route path="/mes-workcenter" element={<MesWorkCenter />} />
                <Route path="/mes-tasks" element={<MesTasks />} />
                <Route path="/mes-operators" element={<MesOperators />} />
              </Route>
            </Routes>
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
};

export default Routing;
